/*
 * @Author: Gang Jiang 
 * @Date: 2024-09-18 11:01:35 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-14 16:21:38
 */

import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import router from './router/router'
import DatePicker from 'ant-design-vue/es/date-picker/moment';
import TimePicker from 'ant-design-vue/es/time-picker/moment';
import Calendar from 'ant-design-vue/es/calendar/moment';
import moment from 'moment-timezone';
import { notification } from 'ant-design-vue'

import copyDirective from './directives/v-copy';

import './assets/less/common.less'
const app = createApp(App);

router.beforeEach((to, from, next) => {
  document.title = to.meta && to.meta.title ? to.meta.title : 'In Rewards';

  if (to.matched.length) {
    if (to.matched.some(record => record.name != 'login')) { // 判断该路由是否需要进行鉴权
      // 获取token
      const token = localStorage.getItem('adminToken');

      if (!token) { // token不存在，则跳转到登录页
        next('/login');
      } else { // token存在，则进行下一步路由
        next();
      }
    } else {
      next(); // 不需要进行鉴权，直接进行下一步路由
    }
  } else {
    next('/404');
  }
});

notification.config({
  placement: 'bottomRight',
  bottom: '50px',
  duration: 3,
  rtl: true,
});

moment.tz.setDefault('America/Los_Angeles');

app.directive('copy', copyDirective);

app.config.productionTip = false;
app.use(router).use(Antd).use(DatePicker).use(TimePicker).use(Calendar).mount('#app');

